import Footer from "../Footer";
import Header from "../Header";
import ScrollToTop from "../ScrollToTop";

// About.jsx
const About = () => {
  return (
   <div>
    <Header />
     <div className="px-8 py-16 bg-gray-50">
      <h2 className="text-3xl font-bold text-center text-gray-800">
        About Us
      </h2>
      <div className="max-w-4xl mx-auto mt-8 leading-relaxed text-gray-700">
        <p className="mb-6">
          At <span className="font-semibold text-blue-600">New World Surveyor</span>, 
          we specialize in delivering professional land surveying services that 
          combine precision, reliability, and innovation. Our mission is to help 
          property owners, developers, and communities make informed decisions 
          about their land.
        </p>
        <p className="mb-6">
          We provide a wide range of surveys — from boundary and topographic 
          mapping to subdivision planning, environmental assessments, and 
          industrial site surveys. Each project is handled with care, using 
          advanced technology and industry best practices to ensure accuracy.
        </p>
        <p className="mb-6">
          What sets us apart is our commitment to our clients. We believe in 
          clear communication, transparency, and treating every customer with 
          respect. Whether you’re a homeowner protecting your property rights or 
          a developer planning a large-scale project, we’re here to guide you 
          every step of the way.
        </p>
        <p>
          Our team is passionate about building trust and long-term 
          relationships. We don’t just measure land — we provide peace of mind 
          and confidence for your future projects.
        </p>
      </div>
    </div>
    <ScrollToTop />
        <Footer />
   </div>
  );
};

export default About;
